(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router',

                /**
                 * Parte do mecanismo de paginação. Permite a customização do template de paginação usado
                 * na visualização de resultados em lista.
                 * 
                 * Adicionado inicialmente para suprir demanda do processos por paginação no backend.
                 * 
                 * @autor Rodrigo Barreiros
                 */
                'angularUtils.directives.dirPagination',
                
                /**
                 * Parte do mecanismo de inserção de documentos. Permite o upload de arquivos do cliente
                 * para o servidor.
                 * 
                 * Adicionado inicialmente para suprir demanda do processos por inclusão de peças.
                 * 
                 * @autor Rodrigo Barreiros
                 */
                'angularFileUpload',

                /**
                 * Parte do mecanismo de visualização em árvore. Permite a customização de templates 
                 * relacionados à estrutura da árvore.
                 * 
                 * Adicionado inicialmente para suprir demanda do processos por visualização 
                 * hierárquica da cadeia de incidentes.
                 * 
                 * @autor Rodrigo Barreiros
                 */
                'ivh.treeview'

            ]);
})();